module.exports = __webpack_public_path__ + "media/images/bg-dotted-b4fd1d3e936fcffe5ef6e7e8b736c363.svg";